module.exports = __webpack_public_path__ + "media/images/user-icon-ef792041afff09dfb52789677e9f410d.svg";